import React from "react";

const ProfileSidebar = ({ activeTab, setActiveTab }) => {
  return (
    <div className="profile-sidebar card border-0">
      <div className="card-body">
        <h6 className="sidebar-title">My Profile</h6>

        <ul className="list-unstyled sidebar-menu">
          <li
            className={activeTab === "profile" ? "active" : ""}
            onClick={() => setActiveTab("profile")}
          >
            Profile Information
          </li>

          <li
            className={activeTab === "address" ? "active" : ""}
            onClick={() => setActiveTab("address")}
          >
            My Addresses
          </li>
          <li
            className={activeTab === "referrewards" ? "active" : ""}
            onClick={() => setActiveTab("referrewards")}
          >
            Refer Rewards
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProfileSidebar;
